import { _CO, _MONTHS } from "../../../utils/constants";
import { createColumn } from "../../../utils/AgGridUtils/ColumnBuilders/createColumn";

const ColumnBuilder = () => {
  const generatedColumns = [];

  generatedColumns.push({
    headerName: "Activities",
    field: "activity",
    hide: true,
    rowGroup: true,
  });
  generatedColumns.push({
    headerName: "Activities/Sites",
    field: "site",
    showRowGroup: "activity",
    cellRenderer: "agGroupCellRenderer",
    minWidth: 200,
  });

  for (let i = 1; i <= 12; i++) {
    const fiscalMonthIndex = _CO[i];
    generatedColumns.push(
      createColumn({
        headerName: _MONTHS[fiscalMonthIndex],
        field: `months.${fiscalMonthIndex}`,
        editable: true,
        headerClass: "month-header",
        cellDataType: "number",
        valueFormatter: (params) => {
          return params.value ? `${params.value} %` : " 0 %";
        },
        valueParser: (params) => parseFloat(params.newValue),
        cellStyle: (params) => {
          const color = params.value > 100 ? "red" : "black";

          return { color: color };
        },
      }),
    );
  }

  return generatedColumns;
};
export default ColumnBuilder;
